export default __webpack_public_path__ + "static/media/playButton.9a3da8f6.svg";